"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _CmsLayout = _interopRequireDefault(require("../components/CmsLayout"));

var _redux = require("../redux");

var _package = require("../../package.json"); // import app components


var Dashboard = function Dashboard(props) {
  var _site$deployment, _site$deployment2;

  var fields = props.fields;

  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      _ref$cms = _ref.cms,
      site = _ref$cms.site,
      siteLoaded = _ref$cms.siteLoaded,
      unpublishedChanges = _ref$cms.unpublishedChanges;

  var dispatch = (0, _redux.useAppDispatch)();

  var _ref2 = (0, _react.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      loading = _ref3[0],
      setLoading = _ref3[1];

  var lastBuild = site === null || site === void 0 ? void 0 : (_site$deployment = site.deployment) === null || _site$deployment === void 0 ? void 0 : _site$deployment.lastBuild;
  (0, _react.useEffect)(function () {
    siteLoaded && dispatch(_redux.siteActions.getUnpublishedChanges());
  }, [siteLoaded, lastBuild]);

  var handleDeploy = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return _redux.siteActions.deploySite();

            case 3:
              setLoading(false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleDeploy() {
      return _ref4.apply(this, arguments);
    };
  }();

  var deploymentButton = site !== null && site !== void 0 && (_site$deployment2 = site.deployment) !== null && _site$deployment2 !== void 0 && _site$deployment2.buildHook ? [/*#__PURE__*/_react.default.createElement(_antd.Button, {
    key: "deploy",
    type: "primary",
    onClick: handleDeploy,
    children: "Deploy Website",
    loading: loading
  })] : null;
  return /*#__PURE__*/_react.default.createElement(_CmsLayout.default, {
    fields: fields,
    pageTitle: "Dashboard"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 40
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Unpublished changes",
    extra: deploymentButton
  }, unpublishedChanges === null ? /*#__PURE__*/_react.default.createElement(_antd.Skeleton, {
    paragraph: {
      rows: 4
    },
    active: true
  }) : unpublishedChanges.length ? /*#__PURE__*/_react.default.createElement(_antd.List, {
    dataSource: unpublishedChanges,
    renderItem: function renderItem(o) {
      return /*#__PURE__*/_react.default.createElement(_antd.List.Item, {
        actions: [/*#__PURE__*/_react.default.createElement("span", {
          key: "type"
        }, o.actionType)]
      }, /*#__PURE__*/_react.default.createElement(_antd.List.Item.Meta, {
        title: (0, _htmlReactParser.default)(o.title || ''),
        description: (0, _htmlReactParser.default)(o.description || '')
      }));
    }
  }) : /*#__PURE__*/_react.default.createElement(_antd.Empty, {
    description: 'No changes'
  })), /*#__PURE__*/_react.default.createElement(_antd.Typography.Text, {
    type: "secondary",
    style: {
      fontSize: 14
    }
  }, "Version: ", _package.version)));
};

var _default = Dashboard;
exports.default = _default;